import { Text } from "../../Base";
import { View } from "../../View";
import { makeStyles } from "@mui/styles";
import { memo } from "react";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  routeCode: {
    color: palette.routeOrange,
  },
});

export const PopUpItem = memo(({ collection }) => {
  const styles = useStyles();

  return (
    <View>
      <Text className={styles.routeCode}>Route {collection?.routeCode}</Text>
      <View>Account Name: {collection?.accountName}</View>
      <View>
        Scheduled Collection Ref: {collection?.scheduledCollectionRef}
      </View>
      <View>Scheduled Time: {collection?.scheduledTime}</View>
      <View>Average Parcels: {collection?.averageParcels}</View>
    </View>
  );
});
